(() => {
    // hide swatches based on product metafield
    const hideSwatches = () => {
        const productCards = Array.from(document.querySelectorAll('product-card:not(.hidden-swatches)'))
        productCards.forEach((card) => {
            const swatchesContainer = card.querySelector('.card__swatches')
            const link = card.querySelector('.card-link')?.href
            if (!swatchesContainer || !link) return
            card.classList.add('hidden-swatches')
            fetch(`${link}?view=hidden-options`)
                .then((res) => res.json())
                .then((json) => {
                    json.hiddenOptions.forEach((option) => {
                        Array.from(swatchesContainer.querySelectorAll(`input[value="${option}"], input[value="${option}"] + label`)).forEach((el) => {
                            el.style.display = 'none'
                        })
                    })
                    const checkedInput = swatchesContainer.querySelector('input[type="radio"]:checked')
                    const checkedInputDisplay = window.getComputedStyle(checkedInput).display;
                    if (checkedInputDisplay === 'none') {
                        Array.from(swatchesContainer.querySelectorAll('input[type="radio"]')).find((input) => {
                            const inputDisplay = window.getComputedStyle(input).display;
                            if (inputDisplay !== 'none') {
                                input.checked = true
                            }
                        })
                    }
                    swatchesContainer.style.opacity = 1
                })
        })
    }
    window.addEventListener('DOMContentLoaded', () => {
        hideSwatches()
    })

    const stickyFilters = () => {
        window.addEventListener('load', () => {
            const headerHeight = document.querySelector('store-header')?.offsetHeight - document.querySelector('store-header.header .header__search')?.offsetHeight;
            if (headerHeight) {
                const style = document.createElement('style');
                style.textContent = `
                    @media (max-width: 768px) {
                        .products-toolbar {
                            position: sticky!important;
                            top: ${headerHeight - 4}px!important;
                            z-index: 4!important;
                            background: #fff!important;
                            padding-top: 16px!important;
                        }
                        .products-toolbar--compare-shift-xs .products-toolbar__compare {
                            top: -60%!important;
                        }
                        store-header.header.is-stuck .header__search {
                            display: none;
                        }
                    }
                `;
                document.head.append(style);
            }
            const headerContainer = document.querySelector('store-header.header').closest('.shopify-section')
            const observer = new IntersectionObserver(
                ([e]) => e.target.querySelector('store-header.header').classList.toggle('is-stuck', e.intersectionRatio < 1),
                { threshold: [1] }
            );

            observer.observe(headerContainer);
        })
    }
    stickyFilters()

    const productGrid = document.querySelector('.main-products-grid__results')
    const observer = new MutationObserver((mutations) => {
        window.setTimeout(() => {
            hideSwatches()
        }, 100)
    })
    observer.observe(productGrid, {
        attributes: true
    })
})()